module.exports = __webpack_public_path__ + "static/media/bg.bc657eeb.png";